import { IoPeopleSharp } from 'react-icons/io5'
import { retrunAssets, returnNotImage } from '../../utils/getAssets'
import { MdArrowForward } from 'react-icons/md'
import { FaArrowRight, FaDownload } from 'react-icons/fa6'
import { Link } from 'react-router-dom'
import { DecodeHtml } from '../../utils/decodeHtml'
import Heading from '../heading'

const About = ({ college }) => {
  const blueText = college?.blueText

  const collegeDescription = college?.collegeDescription.markup
  const collegeBuildingImage =
    college?.collegeBuildingImage != null
      ? retrunAssets(college?.collegeBuildingImage[0]?.url)
      : ''

  return (
    <div className='flex flex-col justify-center gap-16 p-4 md:px-10 items-center bg-[#F2F3F4]'>
      <div className='flex flex-col  gap-10 container mt-12'>
        <div className='grid grid-cols-1 lg:grid-cols-2 place-items-center gap-10'>
          <div className='grid grid-cols-1 gap-5'>
            <Heading name={blueText} color='text-blue-700' />
            <img
              src={collegeBuildingImage || returnNotImage()}
              alt='sideImage'
              className='w-full h-full min-h-[30rem] border-2 bg-gray-100 object-cover rounded-lg'
            />
          </div>
          {DecodeHtml({ html: collegeDescription })}
        </div>
      </div>
    </div>
  )
}

export default About
